import { render, staticRenderFns } from "./index-api.vue?vue&type=template&id=84d973ba"
import script from "./index-api.vue?vue&type=script&lang=js"
export * from "./index-api.vue?vue&type=script&lang=js"
import style0 from "./index-api.vue?vue&type=style&index=0&id=84d973ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports